import { render, staticRenderFns } from "./RegisterDomain.vue?vue&type=template&id=b1720940&scoped=true"
import script from "./RegisterDomain.vue?vue&type=script&lang=js"
export * from "./RegisterDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1720940",
  null
  
)

export default component.exports